import { StyleSheet } from '@react-pdf/renderer';

const commonStyles = StyleSheet.create({
  commonContainer: {
    display: 'flex',
    flexDirection: 'row',
    paddingHorizontal: 16,
    gap: 16,
    marginTop: 16,
  },
});

export const resultPageStyles = StyleSheet.create({
  pageFont: {
    fontFamily: 'Sarabun',
  },
  minimumTrackHeaderContainer: {
    ...commonStyles.commonContainer,
    marginTop: 0,
    gap: 0,
  },
  trackExplanationAspirationsContainer: {
    ...commonStyles.commonContainer,
    marginTop: 4,
  },
  suggestedCareerPathsContainer: {
    ...commonStyles.commonContainer,
  },
  bestFitCareerPathsContainer: {
    ...commonStyles.commonContainer,
  },
  markersOfSuccessContainer: {
    paddingHorizontal: 16,
    marginTop: 16,
  },
});
